import { render, staticRenderFns } from "./ModalQuit.vue?vue&type=template&id=03b5a18e&"
import script from "./ModalQuit.vue?vue&type=script&lang=js&"
export * from "./ModalQuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports